import React, { useEffect, useState } from "react";

const Careers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div id="cover">
        <img
          src={require("../../Assets/images/career-overlay.jpeg")}
          class="prx"
          alt="hani"
          style={{ height: "205px ", width: "100%" }}
        />
        <h1>{rtl ? `التوظيف` : fr ? `Carrières` : `Careers`}</h1>
      </div>

      <div id="bodycont" className="bg">
        <div class="pagewrap">
          <div class="wrapper grid5">
            <article class="fluid animated fadeInRight">
              <div class="col">
                <div class="left-nav">
                  <ul>
                    <li>
                      <a>
                        {rtl ? `الفرص` : fr ? `Opportunités` : `Opportunities`}
                      </a>
                    </li>
                    <li>
                      <a>
                        {rtl
                          ? `التدريب والتأهيل`
                          : fr
                          ? `Formation et Développement`
                          : `Training & Develpoment`}
                      </a>
                    </li>
                    <li>
                      <a>
                        {rtl
                          ? `مجتمع المواهب`
                          : fr
                          ? `Communauté des Talents`
                          : `Talent Community`}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </article>
            <article class="fluid three animated fadeInDown">
              <div class="col">
                <div class="breadcrumb">{/* <h1>CAREERS</h1> */}</div>

                <h1>
                  {rtl
                    ? `وظائف مكة  والمدينة القابضة   وثقافة الشركة`
                    : fr
                    ? `CARRIÈRES MMH ET CULTURE D'ENTREPRISE`
                    : `MMH Careers & Company Culture`}
                </h1>
                <p>
                  {rtl
                    ? `تقدم مكة  والمدينة القابضة   فرصا وظيفية مثيرة في جميع أنحاء العالم. نحن نجذب أفضل الموظفين ونساعدهم على التعلم والنمو وتحقيق أحلامهم من خلال التوجيه والمساعدة الأخرى في التطوير الوظيفي. نحن نشجع جميع الموظفين على الاستفادة الكاملة من إبداعاتهم ومواهبهم ، والتي نعترف بها ونكافئها بانتظام.
ثقافتنا هي التي توفر بيئة عمل إيجابية ومنتجة لتعزيز التقدم الوظيفي والتطوير المهني لموظفينا من خلال توفير تعويض عادل وبيئة عمل رائعة.
`
                    : fr
                    ? ` MMH offre des opportunités de carrière passionnantes dans le monde entier. Nous attirons les meilleurs employés et les aidons à
                    apprendre, à se développer et à réaliser leurs rêves grâce au mentorat et à d'autres formes d'aide au développement de carrière.
                    Nous encourageons tous les employés à exploiter pleinement leur créativité et leurs talents, que nous reconnaissons et
                    récompensons régulièrement. Notre culture est celle d'un environnement de travail positif et productif qui favorise l'avancement
                    de la carrière et le développement professionnel de nos employés en leur offrant une rémunération équitable et un environnement
                    de travail agréable.`
                    : ` MMH offers exciting career opportunities
                                    across the world. We attract the best
                                    employees and help them learn, grow and
                                    realize their dreams through mentoring and
                                    other career development assistance. We
                                    encourage all employees to make full use of
                                    their creativity and talents, which we
                                    regularly recognize and reward. Our culture
                                    is one that provides a positive and
                                    productive working environment to enhance
                                    our employees' career advancement and
                                    professional development by providing
                                    equitable compensation and great working
                                    environment.`}
                </p>

                <br />
                <br />
                <br />

                <div class="right-box-prod-full">
                  <h1>
                    {rtl ? `الفرص` : fr ? `Opportunitès` : `Opportunities`}
                  </h1>
                  <img
                    src={require("../../Assets/images/opportunities.png")}
                    class="imgleft"
                  />
                  <p>
                    {rtl
                      ? `ومن خلال تقييم الفوائد الفريدة للتنوع، فإننا نوظف عددا كبيرا من المغتربين من خلفيات متنوعة من أكثر من 20 دولة، مما يوفر مزايا جذابة وفرصا قيمة لتطوير مهاراتهم ووظائفهم.`
                      : fr
                      ? `Valorisant les avantages uniques de la diversité, nous employons un grand nombre d'expatriés d'origines diverses, originaires de
                      plus de 20 pays, qui bénéficient d'avantages attrayants et d'opportunités précieuses pour faire progresser leurs compétences et
                      leurs carrières.`
                      : `Valuing the unique benefits of
                                        diversity, we employ a large number of
                                        expatriates from a variety of
                                        backgrounds from over 20 countries,
                                        offering attractive benefits and
                                        valuable opportunities to advance their
                                        skills and careers.`}
                  </p>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `التدريب والتطوير`
                      : fr
                      ? `Formation et Développement`
                      : `Training & Development`}
                  </h1>
                  <img
                    src={require("../../Assets/images/training.png")}
                    class="imgleft"
                  />
                  <p>
                    {rtl
                      ? `نحن نعتبر العنصر البشري هو القوة الدافعة والميزة التنافسية لدينا ، حتى أكثر أهمية من الأعمال التجارية والعلامات التجارية والبنية التحتية. نحن نستثمر في حياتك المهنية بدلا من مجرد توفير وظيفة لك. سنقوم بتطوير مواهبك ذات المستوى العالمي لمساعدتنا في مواجهة التحديات المثيرة والهادفة. نحن نعتقد أن مهارات ومعارف وقدرات موظفينا هي أمر أساسي للغاية لاستراتيجية مكة  والمدينة القابضة  للنجاح.`
                      : fr
                      ? `Nous considérons l'élément humain comme notre force motrice et notre avantage concurrentiel, plus important encore que les
                      entreprises, les marques et les infrastructures. Nous investissons dans votre carrière plutôt que de vous fournir un simple emploi.
                      Nous développerons votre talent de classe mondiale pour nous aider à relever des défis passionnants et significatifs. Nous pensons
                      que les compétences, les connaissances et les capacités de notre personnel sont absolument essentielles à la stratégie de réussite
                      de MMH.`
                      : `We consider the human element to be our
                                        driving force and competitive edge, even
                                        more important than business, brands,
                                        and infrastructure. We invest in your
                                        career rather than just providing you a
                                        job. We will develop your world-class
                                        talent to help us tackle exciting and
                                        meaningful challenges. We believe that
                                        the skills, knowledge and capabilities
                                        of our people are absolutely central to
                                        MMH’s strategy for success.`}
                  </p>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `مجتمع المواهب`
                      : fr
                      ? `Communauté des Talents`
                      : `Talent Community`}
                  </h1>
                  <img
                    src={require("../../Assets/images/talent.png")}
                    class="imgleft"
                  />
                  <p>
                    {rtl
                      ? `كجزء من فريقنا ، سنساعدك على تحقيق أقصى إمكاناتك. سنجد المكان المثالي لمهاراتك واهتمامك بمنظمتنا والعالم. العمل في مكة المكرمة والمدينة القابضة ليس مجرد وظيفة، بل هو مهنة مثيرة. انضم إلى مجتمع المواهب لدينا.`
                      : fr
                      ? `En tant que membre de notre équipe, nous vous aiderons à réaliser votre meilleur potentiel. Nous trouverons la place idéale pour
                      vos compétences et vos intérêts dans notre organisation et dans le monde. Travailler à Mecque & la Médine Holding n'est pas un
                      simple emploi, c'est une carrière passionnante. Rejoignez notre communauté de talents.`
                      : `As part of our team we will help you
                                        achieve your greatest potential. We will
                                        find the perfect place for your skills
                                        and interest in our organization and the
                                        world. Working at Makkah & Al madinah
                                        Holding is not just a job, It’s an
                                        exciting career. Join our talent
                                        community.`}
                  </p>
                </div>

                <div class="clear"></div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </>
  );
};

export default Careers;
